// Public route — /coppa-notice. MA-09. The Children's Privacy notice a
// parent reads before the COPPA consent step. DRAFT copy pending legal
// review (banner in LegalPage).
//
// HONESTY NOTE (Principle 1 + 6): the consent + self-serve deletion
// mechanisms (MA-04 / MA-07) are still being built. This copy therefore
// describes the CURRENT private-beta posture truthfully — parent-set-up +
// consent, and deletion handled on request by email — rather than implying a
// finished verifiable-consent flow that does not exist yet. Counsel finalises
// the consent-method wording before public launch (see NEEDS-ALEX.md).
import { createFileRoute } from "@tanstack/react-router";
import { LegalPage, LegalSection } from "@/components/LegalPage";

const LAST_UPDATED = "June 25, 2026";

function CoppaNoticePage() {
  return (
    <LegalPage title="Children's Privacy Notice (COPPA)" lastUpdated={LAST_UPDATED}>
      <LegalSection heading="Why you're reading this">
        <p>
          PencilWise is designed for children ages 4–7, so the U.S.
          Children&apos;s Online Privacy Protection Act (COPPA) applies. This
          notice explains, in plain language, what we collect about your child
          and the rights you have as a parent.
        </p>
      </LegalSection>
      <LegalSection heading="What we collect about your child">
        <p>
          A first name or nickname, an age band (4–7), and your child&apos;s
          practice activity — questions attempted, answers, and skill progress.
          We collect your Google email as the parent so we can reach you and
          manage the account.
        </p>
      </LegalSection>
      <LegalSection heading="Why we collect it">
        <p>
          We use this only to run the app, save progress, and adjust practice to
          your child&apos;s level. We do not use a child&apos;s information for
          advertising or marketing.
        </p>
      </LegalSection>
      <LegalSection heading="We ask for your consent first">
        <p>
          We collect a child&apos;s personal information only after a parent sets
          up the account and gives consent. You set up the account, so your child
          is never asked to share information on their own. During this private
          beta we collect consent from the inviting parent directly; we are
          finalising our full verifiable-consent flow before opening to the
          public.
        </p>
      </LegalSection>
      <LegalSection heading="We don't sell or share it for ads">
        <p>
          We never sell your child&apos;s information and never share it with
          advertisers. We use only a few service providers to run the app (cloud
          storage, sign-in, and error monitoring with personal information
          filtered out). Some features use AI provided by Anthropic.
        </p>
      </LegalSection>
      <LegalSection heading="Your rights as a parent">
        <p>
          You can review the personal information we have about your child, ask
          for a copy, and ask us to delete it. You can also withdraw consent and
          stop further collection. During the private beta, email us and we will
          handle review, export, and deletion requests for you.
        </p>
      </LegalSection>
      <LegalSection heading="How to reach us">
        <p>
          To review, export, or delete your child&apos;s data, or to ask any
          question, email{" "}
          <a className="font-bold underline" href="mailto:support@pencilwise.app">
            support@pencilwise.app
          </a>
          . We&apos;ll confirm you are the parent before acting on a request.
        </p>
      </LegalSection>
    </LegalPage>
  );
}

export const Route = createFileRoute("/coppa-notice")({
  component: CoppaNoticePage,
});
